import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation(); // Get the current location (URL)

  return (
    <div className="md:pr-20  md:pl-[120px] px-2 md:mb-6 md:mt-10 mb-5 mt-5">
    <div className="bg-[#2E453D] p-2 rounded-md">
    <div className="  flex md:flex-row md:space-x-6 space-x-1 ">
        {/* Socials Section */}
        <div className="md:w-1/2  p-2">
          <h3 className="font-bold text-white text-[14px] md:text-[36px] mb-2">Socials</h3>

          <div className="flex flex-wrap justify-start sm:justify-start gap-2 mb-1 md:gap-12 mt-3 md:mb-10">
            <a href="https://www.facebook.com/profile.php?id=100091754654500" className="hover:opacity-75"><img src="/facebook.png" alt="Facebook" className="w-4 h-4 md:w-10 md:h-10" /></a>
            <a href="https://www.instagram.com/farmnet.africa/" className="hover:opacity-75"><img src="/instagram.png" alt="Instagram" className="w-4 h-4 md:w-10 md:h-10" /></a>
            <a href="https://www.tiktok.com/@farmnet_africa" className="hover:opacity-75"><img src="/tiktok.png" alt="TikTok" className="w-4 h-4 md:w-10 md:h-10" /></a>
            <a href="https://youtube.com/@farmnetafrica?si=vvuSecI94w-LBYpz" className="hover:opacity-75"><img src="/youtube.png" alt="YouTube" className="w-4 h-4 md:w-10 md:h-10" /></a>
            <a href="https://www.linkedin.com/in/farmnet/" className="hover:opacity-75"><img src="/linkedin.png" alt="LinkedIn" className="w-4 h-4 md:w-10 md:h-10" /></a>
            <a href="https://www.twitter.com/@FarmNet_africa" className="hover:opacity-75"><img src="/twitter.png" alt="Twitter" className="w-4 h-4 md:w-10 md:h-10" /></a>
            <a href="https://wa.me/+27732372620" className="hover:opacity-75"><img src="/whatsapp.png" alt="WhatsApp" className="w-4 h-4 md:w-10 md:h-10" /></a>
          </div>
          <a href='Register_As_Farm'>

          <button className="relative  w-[150px] md:w-[560px] mt-1 md:mt-5 shadow-md shadow-gray-900  text-white font-bold px-2 py-1 md:py-2.5 md:rounded-br-[10px] md:rounded-bl-[10px] rounded-md text-[7px] md:text-[30px] text-center"
             style={{
            background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}>
  <span className="block text-center">Register as a Farmer</span>
  <img 
          src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754855134/image_1804_usbobp.png" 
          alt="Register icon"
          className="absolute right-1 md:right-2 top-[61%] transform -translate-y-1/2 w-[22px] h-[22px] md:w-[95px] md:h-[95px] object-contain"
          
        />
</button>

</a>
      
        </div>

        {/* Links Section */}
        <div className="md:w-1/2  w-[45%] md:mt-0 ">
          {/* Header and Button inline */}
          <div className="flex flex-row justify-between md:space-x-3  items-center">
            <h3 className="font-bold text-[14px] text-white md:text-[36px] md:pt-4">Links</h3>

            {/* Conditionally Render the Button */}
         <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750719397/image_2_gxofvh.png" alt="jokin" className='md:w-[90px] w-[20px] h-[20px] md:h-[90px]'/>
          </div>

          {/* Footer Links */}
          <ul className="md:-space-y-2 -space-y-3">
            <li><Link to="/Terms_Condition" className="text-[6px] md:text-[30px] text-white hover:underline">Terms and conditions</Link></li>
            <li><Link to="/PrivacyPolicy" className="text-[6px] md:text-[30px] text-white hover:underline">Privacy policy</Link></li>
            <li><Link to="/Data_Policy" className="text-[6px] md:text-[30px] text-white hover:underline">Data Policy</Link></li>
            <li><Link to="/Faqs" className="text-[6px] md:text-[30px] text-white hover:underline">Frequently asked questions (FAQS)</Link></li>
            <li><Link to="/Contact" className="text-[6px] md:text-[30px] text-white hover:underline">Contact Us</Link></li>
          </ul>
        </div>
      </div>
      <h1 className='md:text-[24px]  text-[6px] font-bold  text-white text-right md:mt-0 -mt-3'>@2025 Farmers Networks </h1>
    </div>
    </div>
  );
};

export default Footer;
